import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Container, Row } from "react-bootstrap";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import { useTranslation } from "react-i18next";
import { yesOrNo } from "../../citizen/TCPForms/data";
import FileUploader from "../../citizen/AVPForms/reusableComponents/FileUploader2";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { Accordion, AccordionDetails, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CustomAccordionSummary } from "../../citizen/AVPForms/components/StyledComponent";

const PurchasableFARInfo = ({ formData, handleTabChange, isEmployee, handleNoWorkflowPFAR, isJE, handleGetSiteInspectionById, workflowHistory }) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const isDA = formData?.department === "DA";
  const userInfo = Digit.UserService.getUser();
  const isCTP = userInfo?.info?.roles?.some((role) => role.code === "CTP");
  const isVC = userInfo?.info?.roles?.some((role) => role.code === "Vice_Chairman");
  const isVCChosen = formData?.vcChosen || false;
  const isApprovalUIShow = isCTP && isVCChosen;
  const jeDoneBy = workflowHistory?.timeline?.find((item) => item?.status === "FORWARD_TO_JE")?.assignes?.[0]?.name || "";
  console.log(workflowHistory, jeDoneBy, "wwwwww");

  const defaultValues = {
    plotLeaseHold: formData?.plotLeaseHold,
    letterFrom: formData?.letterFrom || "Committee In-Charge",
    letterTo:
      formData?.letterTo ||
      `Chief Engineer, PWD\nChief Engineer, Jal Nigam\nDistrict Magistrate\nChief Town and Country Planner\nChief Fire Officer, Fire Department`,
    pFARDate: formData?.pFARDate,
    pFARTime: formData?.pFARTime ? (dayjs(formData?.pFARTime, "HH:mm:ss").isValid() ? dayjs(formData.pFARTime, "HH:mm:ss") : null) : null,
    basicFAR: formData?.basicFAR,
    purchasableFAR: formData?.purchasableFAR,
    premiumFAR: formData?.premiumFAR,
    pFAR: {
      siteInspectionDate: formData?.inspectionDetailData?.siteInspecionDateArea || formData?.pFAR?.siteInspectionDate,
      doneBy: jeDoneBy || formData?.pFAR?.doneBy,
      technicalCommitteeDate: formData?.pFAR?.technicalCommitteeDate,
      dfbc: {
        permittedFactor: formData?.pFAR?.dfbc?.permittedFactor,
        cost: formData?.pFAR?.dfbc?.cost,
      },
      purchasable: {
        permittedFactor: formData?.pFAR?.purchasable?.permittedFactor,
        cost: formData?.pFAR?.purchasable?.cost,
      },
      premiumPFAR: {
        permittedFactor: formData?.pFAR?.premiumPFAR?.permittedFactor,
        cost: formData?.pFAR?.premiumPFAR?.cost,
      },
    },
  };
  const { handleSubmit, control, reset, watch, setValue, getValues } = useForm({ defaultValues });

  const watchplotLeaseHold = watch("plotLeaseHold");
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  //   useEffect(() => {
  //   const fetchDetails = async () => {
  //     if (!formData?.applicationNo) return;
  //     const details = await handleGetSiteInspectionById(formData.applicationNo);
  //     console.log(details, "post-details");
  //     const inspectionDetails = details?.DetailDataRemarks?.[0]?.inspectionDetails;
  //     setValue(
  //       "pFAR.siteInspectionDate",
  //       inspectionDetails?.siteInspecionDateArea || null
  //     );
  //     setValue("pFAR.doneBy", userInfo?.info?.name);
  //   };

  //   fetchDetails();
  // }, [formData?.applicationNo]);
  useEffect(() => {
    if (jeDoneBy) {
      setValue("pFAR.doneBy", jeDoneBy);
    }
  }, [jeDoneBy]);

  const onSubmit = (data) => {
    console.log(data, "submittedData");

    data.pFARTime = dayjs(data.pFARTime).format("HH:mm:ss");
    // data.pFAR.siteInspectionDate = formData?.inspectionDetailData?.siteInspecionDateArea || data.pFAR.siteInspectionDate;
    // data.pFAR.doneBy = jeDoneBy || data.pFAR.doneBy;
    if (isVC) {
      data.vcChosen = true;
    }
    handleNoWorkflowPFAR(data);
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Purchasable FAR")}</h2>
          </div>

          <Container className="formInputContainer" fluid>
            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={"Applicant has applied for PurchasableFAR, do you wish to continue"}
                  name="plotLeaseHold"
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  defaultValue={formData?.plotLeaseHold}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col> */}
              <Col>
                <InputWrapper
                  label={t("Purchasable FAR")}
                  control={control}
                  name="purchasableFAR"
                  mandatory
                  defaultValue={formData?.purchasableFAR}
                  type="textInput"
                  placeholder={t("Enter Purchasable FAR")}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Basic FAR")}
                  control={control}
                  name="basicFAR"
                  mandatory
                  placeholder={t("Enter Basic FAR")}
                  defaultValue={formData?.basicFAR}
                  type="textInput"
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Premium FAR")}
                  control={control}
                  name="premiumFAR"
                  mandatory
                  defaultValue={formData?.premiumFAR}
                  type="textInput"
                  placeholder={t("Enter Premium FAR")}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Location")}
                  placeholder={t("Enter Location")}
                  control={control}
                  name="locationZone"
                  mandatory
                  defaultValue={formData?.locationZone}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Controller
                  name="letterFrom"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      label="From"
                      placeholder="Enter details here"
                      fullWidth
                      required
                      multiline
                      rows={4} // adjust rows as per need
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Col>

              <Col>
                <Controller
                  name="letterTo"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      label="To"
                      placeholder="Enter details here"
                      fullWidth
                      required
                      multiline
                      rows={4}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Select Date")}
                  control={control}
                  placeholder={t("Select date")}
                  name="pFARDate"
                  defaultValue={formData?.pFARDate}
                  type="datePicker"
                />
              </Col>
              <Col>
                <InputWrapper label={t("Time")} control={control} placeholder={t("Select time")} name="pFARTime" type="timePicker" />
              </Col>
            </Row>
            {/* isVC role condition TBA: */}
            {isApprovalUIShow && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Site Inspection Date")}
                    control={control}
                    placeholder={t("Select date")}
                    name="pFAR.siteInspectionDate"
                    defaultValue={formData?.inspectionDetailData?.siteInspecionDateArea || formData?.pFAR?.siteInspectionDate}
                    type="datePicker"
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Done By")}
                    placeholder={t("Done By")}
                    control={control}
                    name="pFAR.doneBy"
                    mandatory
                    defaultValue={jeDoneBy || formData?.pFAR?.doneBy}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}

            {isApprovalUIShow && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Date of Technical Committee Meeting")}
                    control={control}
                    placeholder={t("Select date")}
                    name="pFAR.technicalCommitteeDate"
                    defaultValue={formData?.pFAR?.technicalCommitteeDate}
                    type="datePicker"
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            {isApprovalUIShow && (
              <Accordion sx={{ width: "100%", marginTop: "8px 0px 8px 0px" }}>
                <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{t("PFAR Detail")}</h2>
                  </div>
                </CustomAccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} sx={{ mt: 2, mb: 2, borderRadius: "8px" }}>
                    <Table>
                      {/* Table Header */}
                      <TableHead>
                        <TableRow>
                          {!isDA && (
                            <TableCell align="center" sx={{ fontWeight: "bold", fontSize: "16px" }}>
                              Differential FAR Benefit Charges (DFBC)
                            </TableCell>
                          )}
                          <TableCell align="center" sx={{ fontWeight: "bold", fontSize: "16px" }}>
                            Purchasable FAR Charges
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: "bold", fontSize: "16px" }}>
                            Premium Purchasable FAR Charges
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {/* Row 1: Permitted Factor */}
                        <TableRow>
                          {!isDA && (
                            <TableCell>
                              <InputWrapper
                                hasLabel={isDA}
                                label={"Permitted Factor"}
                                name="pFAR.dfbc.permittedFactor"
                                control={control}
                                type="textInput"
                                placeholder="Enter Permitted Factor"
                                // mandatory
                                defaultValue={formData?.pFAR?.dfbc?.permittedFactor || ""}
                              />
                            </TableCell>
                          )}

                          <TableCell>
                            <InputWrapper
                              hasLabel={isDA}
                              label={"Permitted Factor"}
                              name="pFAR.purchasable.permittedFactor"
                              control={control}
                              type="textInput"
                              placeholder="Enter Permitted Factor"
                              // mandatory
                              defaultValue={formData?.pFAR?.purchasable?.permittedFactor || ""}
                            />
                          </TableCell>

                          <TableCell>
                            <InputWrapper
                              hasLabel={isDA}
                              label={"Permitted Factor"}
                              name="pFAR.premiumPFAR.permittedFactor"
                              control={control}
                              type="textInput"
                              placeholder="Enter Permitted Factor"
                              // mandatory
                              defaultValue={formData?.pFAR?.premiumPFAR?.permittedFactor || ""}
                            />
                          </TableCell>
                        </TableRow>

                        {/* Row 2: Cost (in Rs.) */}
                        <TableRow>
                          {!isDA && (
                            <TableCell>
                              <InputWrapper
                                hasLabel={isDA}
                                label={"Cost (in Rs.)"}
                                name="pFAR.dfbc.cost"
                                control={control}
                                type="textInput"
                                placeholder="Enter Cost"
                                // mandatory
                                defaultValue={formData?.pFAR?.dfbc?.cost || ""}
                              />
                            </TableCell>
                          )}

                          <TableCell>
                            <InputWrapper
                              hasLabel={isDA}
                              label={"Cost (in Rs.)"}
                              name="pFAR.purchasable.cost"
                              control={control}
                              type="textInput"
                              placeholder="Enter Cost"
                              mandatory
                              defaultValue={formData?.pFAR?.purchasable?.cost}
                            />
                          </TableCell>

                          <TableCell>
                            <InputWrapper
                              hasLabel={isDA}
                              label={"Cost (in Rs.)"}
                              name="pFAR.premiumPFAR.cost"
                              control={control}
                              type="textInput"
                              placeholder="Enter Cost"
                              mandatory
                              defaultValue={formData?.pFAR?.premiumPFAR?.cost}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            )}

            <Row>
              <Col>
                <FileUploader
                  control={control}
                  name="committeeResponse"
                  label="Committee Response"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                />
              </Col>
              {formData?.farInimationLetterUrl ? (
                <Col>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <label className="fw-bold">Initiation Letter:</label>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      style={{ backgroundColor: "#1F4A7C" }}
                      onClick={() => window.open(formData?.farInimationLetterUrl, "_blank")} // your function
                    >
                      Generate Letter
                    </button>
                  </div>
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              {" "}
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "10px",
                  borderRadius: "5px",
                  color: "#333",
                  marginBottom: "15px",
                  fontWeight: "bold",
                }}
              >
                <p>
                  <strong>Note:</strong> User can fill PFAR detail once committee response is finalized.
                </p>
              </div>
            </Row>
          </Container>
          <div className="footerContainer2">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
              />
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default PurchasableFARInfo;
